import React from "react"

import "./jobHighlight.scss"

export default function JobHighlight() {
  const jobHighlight = {
    experience: "1-2 years",
    job: "Remote",
    job_type: "Full-time",
    salary: "50,000",
  }
  return (
    <div className="job-highlight mb-20px">
      <div className="row ">
        {Object.keys(jobHighlight).map((item, index) => {
          return (
            <div className="col-6" key={index}>
              <div className="highlight-item">
                <p>{item}</p>
                <strong>{jobHighlight[item]}</strong>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
